import { useState, useCallback } from 'react';
import { useDropzone } from 'react-dropzone';
import "../../pages/draft/style/dropzone.scss";

export default ({
    className = 'dropzone',
    draftId,
    onDropMedia
}) => {

    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState(null);

    const getFileType = (extension) => {
        if (extension === 'mp3' || extension === 'wav') {
            return 'AUDIO';
        } else if (extension === 'mp4' || extension === 'mov') {
            return 'VIDEO';
        } else if (extension === 'jpg' || extension === 'jpeg' || extension === 'png') {
            return 'IMAGE';
        }
    }

    const onDrop = useCallback(async (acceptedFiles) => {
        if (acceptedFiles.length === 0) return;

        setUploading(true);
        setError(null);

        try {
            const file = acceptedFiles[0];
            const fileNameParts = file.name.split('.');
            if(fileNameParts.size < 2) {
                throw new Error('Invalid file name' + file.name);
            }

            console.log(fileNameParts.length)

            onDropMedia({
                name: fileNameParts[0],
                type: getFileType(fileNameParts[fileNameParts.length-1]),
                file: file
            });
        } catch (err) {
            console.error('Upload failed:', err);
            setError('Upload failed. Please try again.');
        } finally {
            setUploading(false);
        }
    }, [draftId]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, multiple: false });

    return (
        <div {...getRootProps({
            className: `${className} ${isDragActive ? 'drag-active' : ''}`
        })} >
            <input {...getInputProps()} />
            {isDragActive ? (
                <p>Drop the file here...</p>
            ) : (
                <p>Drag & drop a file here, or click to select one</p>
            )}
            {uploading && <p>Uploading...</p>}
            {error && <p className="text-red-500">{error}</p>}
        </div>
    );
};
